/**
 * @module analytics
 */

/**
 * @typedef {Object} Analytics
 */

/**
 * Analytics GA
 * @type {Analytics}
 */
function Analytics() {
    return {
        /**
         * @property save Send data to DataLayer
         * @param {string} data
         */
        save: function(data) {
            // DataLayer
            if (window.dataLayer) {
                window.dataLayer.push(data);
            }
        },
        /**
         * @property event Send event to DataLayer
         * @param {string} data
         */
        event: function(data) {
            data['event'] = 'eventTracking';
            // DataLayer
            if (window.dataLayer) {
                window.dataLayer.push(data);
            }
        }
    }
}

module.exports = Analytics;